import * as React from "react";
const { useState, useEffect, useMemo } = React;
import { Layout, Menu, Input, Button, Dropdown, Avatar, theme } from 'antd';
const { Sider } = Layout;
import {
    DesktopOutlined,
    FileOutlined,
    PieChartOutlined,
    TeamOutlined,
    UserOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    SearchOutlined,
    LogoutOutlined,
    BellOutlined,
    CreditCardOutlined,
    CrownOutlined
} from '@ant-design/icons';

import {
    Send,
    Download,
    Sparkles,
    History,
    Plus,
    MessageSquare,
    Copy,
    Bell,
    FileText,
    House,
    Mail,
    Bus,
    Database,
    ShieldQuestion,
    ArrowUpDown,
    Table,
    Pencil,
    ChartBar,
    BookMarked,
    Target,
    Settings,
    User,
    Users,
    List
} from 'lucide-react';

const iconMap = {
    "fa fa-lg fa-fw fa-home": House,
    "fa fa-lg fa-fw fa fa-bus": Bus,
    "fa fa-lg fa-fw fa-bar-chart-o": ChartBar,
    "fa fa-lg fa-fw fa-book": BookMarked,
    "fa fa-lg fa-fw fa-bullseye": Target,
    "fa fa-lg fa-fw fa-cog": Settings,
    "fa fa-lg fa-fw fa-group": Users,
    "fa fa-lg fa-fw fa-inbox": Mail,
    "fa fa-lg fa-fw fa-list-alt": List,
    "fa fa-lg fa-fw fa-pencil-square-o": Pencil,
    "fa fa-lg fa-fw fa-question-circle": ShieldQuestion,
    "fa fa-lg fa-fw fa-reorder": ArrowUpDown,
    "fa fa-lg fa-fw fa-table": Table,
    "fa fa-lg fa-fw fa-user": User,
    "fa fa-lg fa-fw fa-users": Users
}

const decode = (url) => url ? url.replace('&amp;', '&') : "";

const NavigationComponent = (props) => {
    const [collapsed, setCollapsed] = useState(false);
    const [apps, setApps] = useState(props.apps);
    const [rootScope] = useState(props.rootScope);
    const [searchText, setSearchText] = useState('');
    const [logo] = useState(props.input.logo);
    const USER_PROFILE_HEIGHT = 60;
    const HEADER_HEIGHT = 116;
    const SEARCH_SECTION_HEIGHT = 50;
    const COLLAPSED_WIDTH = 90;
    const EXPANDED_WIDTH = 240;

    // Smooth transition for all relevant properties
    const transitionStyles = {
        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    };
    // Inside your NavigationComponent
    const scrollbarStyles = {
        overflowY: 'auto',
        overflowX: 'hidden',
        msOverflowStyle: 'none', // for IE
        scrollbarWidth: 'thin',  // for Firefox
        scrollbarColor: 'rgba(255, 255, 255, 0.2) transparent', // for Firefox
    };

    // Add a separate style tag for webkit scrollbar styles
    const scrollbarCSS = `
    .menu-container::-webkit-scrollbar {
        width: 4px;
        background-color: transparent;
    }
    .menu-container::-webkit-scrollbar-thumb {
        background-color: rgba(255, 255, 255, 0.2);
        border-radius: 4px;
    }
    .menu-container::-webkit-scrollbar-track {
        background-color: transparent;
    }
`;

    const siderStyle = {
        background: '#141414',
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
        ...transitionStyles,
    };

    // Updated menu styles with proper React CSS-in-JS naming
    const menuStyle = {
        // background: 'transparent',
        borderRight: 'none',
        width: '100%',
        padding: collapsed ? '4px 0' : '4px',
    };

    // Additional styles for menu items
    const menuItemStyles = {
        height: '40px',
        lineHeight: '40px',
        margin: '4px 0',
        padding: collapsed ? '0' : '0 16px',
    };

    // Styles for the menu item icon
    const menuIconStyles = {
        // minWidth: collapsed ? '16px' : '14px',
        // marginRight: collapsed ? 0 : '10px',
        // display: 'flex',
        // alignItems: 'center',
        // justifyContent: 'center',
    };

    // Handle menu click
    const handleMenuClick = (data) => {
        console.log(data);
        const element = angular.element(document.querySelector('body'));
        const $rootScope = element.scope().$root;
        // Use $apply to ensure Angular knows about the state change
        $rootScope.$apply(() => {
            $rootScope.$broadcast('navigation:changed', collapsed);
        });
        // Update content margins
        const width = collapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH;
        const elements = ['top-menu', 'side-menu', 'content'].map(id =>
            document.getElementById(id)
        );

        elements.forEach(el => {
            if (el) {
                if (el.id === 'content') {
                    Object.assign(el.style, {
                        ...transitionStyles,
                        marginLeft: `${width}px`,
                        width: `calc(100% - ${width}px)`,
                        maxWidth: `calc(100% - ${width}px)`
                    });
                    console.log(el);
                } else {
                    Object.assign(el.style, {
                        ...transitionStyles,
                        ...(el.id === 'side-menu' ? { width: `${width}px` } :
                            el.id === 'top-menu' ? { left: `${width}px` } : {})
                    });
                }
            }
        });
        // Trigger resize event for grids
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 100);
    };

    function getItem(label, key, icon, children, url, type) {
        if (label === "separator") {
            return {
                type: 'divider'
            }
        }
        return {
            key,
            icon: icon ? React.cloneElement(icon, {
                className: "text-blue-500",
                style: menuIconStyles  // Apply the styles here
            }) : null,
            children,
            label,
            url
        };
    }

    const userMenuItems = [
        {
            key: 'profile',
            icon: <UserOutlined />,
            label: <a href={`/pltf_user/${rootScope.ob.user._id}`} rel="noopener noreferrer">
                Account
            </a>
        },
        {
            key: 'upgrade',
            icon: <CrownOutlined />,
            label: <a href={`page?pagename=obpay`} rel="noopener noreferrer">
                Upgarde
            </a>
        },
        {
            key: 'billing',
            icon: <CreditCardOutlined />,
            label: <a href={`page?pagename=obpay`} rel="noopener noreferrer">
                Billing
            </a>
        },
        {
            key: 'notifications',
            icon: <BellOutlined />,
            label: <a href={`page?pagename=usernotifications`} rel="noopener noreferrer">
                Notifications
            </a>
        },
        {
            type: 'divider'
        },
        {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: 'Log out',
            onClick: () => {
                // Access the injector from outside AngularJS code
                const element = angular.element(document.querySelector('body'));
                const rootScope = element.scope().$root;
                rootScope.$broadcast('event:logoutRequest', {});
                const leftSideNav = document.getElementById('side-menu');
                if (leftSideNav) {
                    leftSideNav.style.width = '0px';
                    // Optional: Add transition
                    leftSideNav.style.transition = 'margin-left 0.2s';
                }
            }
        }
    ];

    // Effect to handle collapsed state changes
    useEffect(() => {
        window.__NAV_COLLAPSED__ = collapsed;
        // Get Angular's $rootScope
        const element = angular.element(document.querySelector('body'));
        const $rootScope = element.scope().$root;

        // Use $apply to ensure Angular knows about the state change
        $rootScope.$apply(() => {
            $rootScope.$broadcast('navigation:changed', collapsed);
        });

        // Update content margins
        const width = collapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH;
        const elements = ['top-menu', 'side-menu', 'content'].map(id =>
            document.getElementById(id)
        );

        elements.forEach(el => {
            if (el) {
                if (el.id === 'content') {
                    Object.assign(el.style, {
                        ...transitionStyles,
                        marginLeft: `${width}px`,
                        width: `calc(100% - ${width}px)`,
                        maxWidth: `calc(100% - ${width}px)`
                    });
                } else {
                    Object.assign(el.style, {
                        ...transitionStyles,
                        ...(el.id === 'side-menu' ? { width: `${width}px` } :
                            el.id === 'top-menu' ? { left: `${width}px` } : {})
                    });
                }
            }
        });

        // Trigger resize event for grids
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 100);

    }, [collapsed]);

    // Generate filtered items with proper icon sizing
    const filteredItems = useMemo(() => {
        if (!searchText.trim()) {
            return apps.map((app, appIndex) => {
                const children = app.items.map((subapp, subIndex) => {
                    let uriPart1 = subapp.table ? subapp.table + '/' : '';
                    uriPart1 = subapp.table === "page" ? subapp.table : uriPart1;
                    const uriPart2 = subapp.type || '';
                    const uriPart3 = subapp.argument ? '?' + decode(subapp.argument) : '';

                    return getItem(
                        <a href={`${uriPart1}${uriPart2}${uriPart3}`}>{subapp.title}</a>,
                        `${app.name}-${subapp.name}-${subIndex}`, // Unique key combining parent and child
                        null
                    );
                });

                const AppIcon = iconMap[app.image] || Settings;
                return getItem(
                    app.title,
                    `${app.name}-${appIndex}`, // Unique key for parent
                    React.createElement(AppIcon, {
                        size: collapsed ? 16 : 18,
                        style: { marginRight: collapsed ? 0 : 10 }
                    }),
                    children
                );
            });
        }

        // Search filtering logic
        const searchLower = searchText.toLowerCase();
        return apps.map((app, appIndex) => {
            const filteredChildren = app.items
                .filter(subapp => subapp.title.toLowerCase().includes(searchLower))
                .map((subapp, subIndex) => {
                    let uriPart1 = subapp.table ? subapp.table + '/' : '';
                    uriPart1 = subapp.table === "page" ? subapp.table : uriPart1;
                    const uriPart2 = subapp.type || '';
                    const uriPart3 = subapp.argument ? '?' + decode(subapp.argument) : '';

                    return getItem(
                        <a href={`${uriPart1}${uriPart2}${uriPart3}`}>{subapp.title}</a>,
                        `search-${app.name}-${subapp.name}-${subIndex}`,
                        null
                    );
                });

            if (filteredChildren.length > 0 || app.title.toLowerCase().includes(searchLower)) {
                const AppIcon = iconMap[app.image] || Settings;
                return getItem(
                    app.title,
                    `search-${app.name}-${appIndex}`,
                    React.createElement(AppIcon, {
                        size: collapsed ? 16 : 18,
                        style: { marginRight: collapsed ? 0 : 10 }
                    }),
                    filteredChildren.length > 0 ? filteredChildren : undefined
                );
            }
            return null;
        }).filter(Boolean);
    }, [apps, searchText, collapsed]);


    // Add error boundary around the Menu component
    const MenuWithErrorBoundary = () => {
        try {
            return (
                <Menu
                    theme="dark"
                    mode="inline"
                    onClick={handleMenuClick}
                    items={filteredItems}
                    style={{
                        ...menuStyle,
                        ...menuItemStyles
                    }}
                    defaultOpenKeys={[]}
                />
            );
        } catch (error) {
            console.error('Menu rendering error:', error);
            return <div>Error loading menu</div>;
        }
    };

    return (
        <Layout>
            <Sider
                style={siderStyle}
                width={EXPANDED_WIDTH}
                collapsedWidth={COLLAPSED_WIDTH}
                collapsed={collapsed}
                breakpoint="lg"
                onBreakpoint={broken => {
                    console.log(broken);
                }}
                onCollapse={(collapsed, type) => {
                    console.log(collapsed, type);
                }}
                trigger={null}
            >
                {/* Company Logo Section */}
                <div style={{
                    padding: collapsed ? '12px 8px' : '12px 16px',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    marginBottom: '8px',
                    height: '69px',
                    display: 'flex',
                    alignItems: 'center',
                    ...transitionStyles,
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%'
                    }}>
                        <Avatar
                            style={{
                                backgroundColor: 'transparent',
                                width: collapsed ? 40 : 50,
                                height: collapsed ? 36 : 45,
                                ...transitionStyles,
                            }}
                            src={logo}
                            shape="square"
                        />
                        <Button
                            type="text"
                            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                            onClick={() => setCollapsed(!collapsed)}
                            style={{
                                color: '#fff',
                                width: 28,
                                height: 28,
                            }}
                        />
                    </div>
                </div>

                {/* Search Section */}
                <div style={{
                    padding: '0 16px 16px 16px',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    height: SEARCH_SECTION_HEIGHT,
                    opacity: collapsed ? 0 : 1,
                    ...transitionStyles,
                }}>
                    {!collapsed && (
                        <Input
                            placeholder="Search..."
                            prefix={<SearchOutlined />}
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            style={{
                                background: '#1f1f1f',
                                borderColor: '#303030',
                                color: 'whitesmoke'
                            }}
                            allowClear
                        />
                    )}
                </div>

                {/* Menu Section */}
                <div style={{
                    overflow: 'auto',
                    height: `calc(100vh - ${HEADER_HEIGHT + USER_PROFILE_HEIGHT + 24}px)`,
                    ...scrollbarStyles,
                    ...transitionStyles,
                }}>
                    <style>{scrollbarCSS}</style>
                    <MenuWithErrorBoundary />
                </div>

                {/* User Profile Section */}
                <div style={{
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                    height: USER_PROFILE_HEIGHT,
                    backgroundColor: '#141414',
                    ...transitionStyles,
                }}>
                    <Dropdown
                        menu={{ items: userMenuItems }}
                        trigger={['click']}
                        placement="topRight"
                    >
                        <div style={{
                            padding: collapsed ? '12px 8px' : '12px 16px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: collapsed ? 'center' : 'flex-start',
                            backgroundColor: 'rgba(255, 255, 255, 0.05)',
                            ...transitionStyles,
                        }}>
                            <Avatar
                                src={rootScope.ob.user.display_picture_url}
                                style={{
                                    ...transitionStyles,
                                    marginRight: collapsed ? 0 : '12px'
                                }}
                            />
                            {!collapsed && (
                                <div>
                                    <div style={{ color: '#fff', fontSize: '14px' }}>{rootScope.ob.user.name}</div>
                                    <div style={{ color: '#888', fontSize: '12px' }}>{rootScope.ob.user.email}</div>
                                </div>
                            )}
                        </div>
                    </Dropdown>
                </div>
            </Sider>
        </Layout>
    );
};

export default NavigationComponent;